import { Link, useForm } from '@inertiajs/react'
import type { FormEvent } from 'react'
import AuthShell, { Field, SubmitButton } from '@/components/AuthShell'

export default function ForgotPassword() {
  const form = useForm({ email_address: '' })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.post('/passwords')
  }

  return (
    <AuthShell
      title="找回密码"
      subtitle="输入注册邮箱，我们会发送重置说明。"
      footer={
        <>
          想起来了？<Link href="/session/new" className="text-[#5b7cfa] font-semibold">返回登录</Link>
        </>
      }
    >
      <form onSubmit={submit} className="grid gap-4">
        <Field
          label="邮箱"
          type="email"
          autoComplete="username"
          autoFocus
          required
          value={form.data.email_address}
          error={form.errors.email_address}
          onChange={(e) => form.setData('email_address', e.target.value)}
        />
        <SubmitButton disabled={form.processing}>{form.processing ? '发送中…' : '发送重置说明'}</SubmitButton>
      </form>
    </AuthShell>
  )
}
